import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import auth from './auth/auth';
import ui from './ui/ui';
import tables from "./tables/tables";
import ability from "./ability/ability";
import events from "./events/events";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        ui,
        tables,
        ability,
        events
    },
    plugins: [
        createPersistedState({key:'pets-vuex-store'}),
    ]
});